import pre from './pre';
import post from './post';
import cart from './cart.vue';
import config from './config';
import success from './success.vue';
export default {
  pre,
  post,
  components: {
    config,
    cart,
    success
  },
};
